import React, { useEffect, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import MemoedHOC from "@/hoc/MemoedHOC";
import { makeStyles } from "@material-ui/core/styles";

import CompanyDeviceApi from "@/apis/companyDeviceApi";
import _ from "lodash";

const useModalStyles = makeStyles(() => ({
  DeviceDetailModal: {
    "& .DeviceDetailModalBox": {
      width: "100%",
      height: "100%",
      "& .header-button-box": {
        fontSize: 14,
        color: "#646473",
        display: "flex",
        "& .button": {
          minWidth: 120,
          padding: "0 5px",
          boxSizing: "border-box",
          height: 40,
          borderRadius: 6,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          border: "1px solid #DDDDDD",
          cursor: "pointer",
          "&:first-child": {
            marginRight: 24
          },
          "&.button-active": {
            border: "1px solid #00AFC6",
            color: "#00AFC6"
          }
        }
      },
      "& .detail": {
        paddingTop: 24,
        boxSizing: "border-box",
        fontSize: 14,
        color: "#333333",
        "& .detail-line": {
          borderBottom: "solid 1px #F8F9FC",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          minHeight: 52,
          "& .detail-line-left": {
            minWidth: 50
          },
          "& .detail-line-right": {
            maxWidth: 340,
            wordWrap: "break-word"
          }
        }
      }
    }
  }
}));

function TranserModal({ open, onConfirm, onClose, os_type, rowData }) {
  const { t } = useTranslation();
  const [tab, setTab] = useState(1);
  const [info, setInfo] = useState({});
  const [list, setList] = useState([]); // 设备资讯
  const [deviceEigenvalueList, setDeviceEigenvalueList] = useState([]); // 设备特征值

  const styleClass = useModalStyles();

  const handleConfirm = () => {
    onConfirm();
  };

  const getDetail = async () => {
    const res = await CompanyDeviceApi.GetDeviceDetail(rowData.device_id);
    if (res && res.info) {
      setTab(1);
      setInfo(res.info);
      setDetailList(res.info);
    }
  };

  useEffect(() => {
    // 查询详情
    if (rowData && rowData.device_id) {
      setTimeout(() => {
        getDetail();
      }, 0);
    }
  }, [open, rowData, os_type]);
  const statusOption = {
    inactive: t({ defaultMessage: "未激活" }),
    activated: t({ defaultMessage: "已激活" }),
    registered: t({ defaultMessage: "已注册" })
  };
  const setDetailList = _info => {
    const company_name_arr = [];
    _.each(_info.companies, item => {
      company_name_arr.push(item.name);
    });

    const company_name = company_name_arr.join(",");

    const _list = [
      {
        label: t({ defaultMessage: "设备ID" }),
        value: _info.serial_number
      },
      {
        label: t({ defaultMessage: "设备SN" }),
        value: _info.device_sn
      },
      {
        label: t({ defaultMessage: "设备类型" }),
        value: _info.os_type
      },
      {
        label: t({ defaultMessage: "设备名称" }),
        value: rowData && rowData.device_name
      },
      {
        label: t({ defaultMessage: "状态" }),
        value: statusOption[_info.status]
      },
      {
        label: t({ defaultMessage: "公司" }),
        value: company_name
      },
      {
        label: t({ defaultMessage: "门店" }),
        value: rowData && rowData.company_groups
      },
      {
        label: t({ defaultMessage: "标签" }),
        value: rowData && rowData.company_tags
      },
      {
        label: t({ defaultMessage: "Nubis版本" }),
        value: _info.nubis_version
      }
    ];

    // 安卓特征值
    let _deviceEigenvalueList = [
      {
        label: "Serial",
        value: _info && _info.android && _info.android.serial
      },
      {
        label: "IMEI 1",
        value: _info && _info.android && _info.android.imei_1
      },
      {
        label: "Android ID",
        value: _info && _info.android && _info.android.android_id
      },
      {
        label: "Manufactuer",
        value: _info && _info.android && _info.android.manufacturer
      }
    ];
    // window
    if (_info.os_type === "windows") {
      _deviceEigenvalueList = [
        {
          label: t({ defaultMessage: "主板序列号" }),
          value:
            _info && _info.windows && _info.windows.motherboard_serial_number
        },
        {
          label: t({ defaultMessage: "BIOS序列号" }),
          value: _info && _info.windows && _info.windows.bios_serial_number
        },
        {
          label: t({ defaultMessage: "UUID" }),
          value: _info && _info.windows && _info.windows.uuid
        },
        {
          label: t({ defaultMessage: "Wi-Fi MAC Address" }),
          value: _info && _info.windows && _info.windows.wifi_mac_address
        },
        {
          label: t({ defaultMessage: "Ethernet MAC Address" }),
          value: _info && _info.windows && _info.windows.ethernet_mac_address
        },
        {
          label: t({ defaultMessage: "Manufactuer" }),
          value: _info && _info.windows && _info.windows.manufacturer
        }
      ];
    }

    setDeviceEigenvalueList(_deviceEigenvalueList);

    setList(_list);
  };

  return (
    <Modal
      title={`${info.os_type? info.os_type.charAt(0).toUpperCase() + info.os_type.slice(1):""} ` + t({ defaultMessage: "设备详情" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      className={styleClass.DeviceDetailModal}
      width={420}
      height={550}
    >
      <div class={`DeviceDetailModalBox`}>
        <div class={`header-button-box`}>
          <div
            className={`button ${tab === 1 ? " button-active" : ""}`}
            onClick={() => {
              setTab(1);
            }}
          >
            {t({ defaultMessage: "设备资讯" })}
          </div>
          <div
            className={`button ${tab === 2 ? " button-active" : ""}`}
            onClick={() => {
              setTab(2);
            }}
          >
            {t({ defaultMessage: "设备特征值" })}
          </div>
        </div>
        <div className={`detail`}>
          {tab === 1 &&
            _.map(list, item => {
              return (
                <div className={"detail-line"}>
                  <div className={`detail-line-left`}>{item.label}：</div>
                  <div className={`detail-line-right`}>{item.value}</div>
                </div>
              );
            })}
          {tab === 2 &&
            _.map(deviceEigenvalueList, item => {
              return (
                <div className={"detail-line"}>
                  <div className={`detail-line-left`}>{item.label}：</div>
                  <div className={`detail-line-right`}>{item.value}</div>
                </div>
              );
            })}
        </div>
      </div>
    </Modal>
  );
}

export default MemoedHOC(TranserModal);
